import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { getVerifyPolicyFlow } from 'src/redux/selectors/verifyPolicy';

interface CompletedComplianceFlowGuardProps {
  children: ReactNode;
}

export function CompletedComplianceFlowGuard({
  children,
}: CompletedComplianceFlowGuardProps) {
  const verifyPolicyFlow = useSelector(getVerifyPolicyFlow) as
    | ReturnType<typeof getVerifyPolicyFlow>
    | undefined;

  const hasCompletedComplianceFlow =
    verifyPolicyFlow?.userFinishedComplianceFlow;

  if (hasCompletedComplianceFlow) {
    return <Navigate to={ROUTES.COMPANY_PATH} replace={true} />;
  }

  return <>{children}</>;
}
